module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-ExtraBold.4608d124.woff";